<template>
  <el-dialog
    title="编辑字段"
    :visible.sync="dialogVisible"
    append-to-body
    :close-on-click-modal='false'
    class="default-dialog cashierdiary--edit-dialog"
    width="890px"
   >
    <div class="cashierdiary--edit-dialog-wrapper" v-loading="loading">
      <!-- 自定义字段 -->
      <div class="cashierdiary--edit-dialog-wrapper-usering" v-if="useList.length">
         <div class="cashierdiary--edit-dialog-wrapper-title">
           <span>收入字段</span>
           <public-tips content="已添加字段不能修改格式类型,只能修改基本属性"></public-tips>
         </div>
         <!-- 列表 -->
         <div class="cashierdiary--edit-dialog-wrapper-list">
            <edit-list
              :listType="1"
              @getList="getList($event,1)"
              :dataList="useLists"
              :fillRule="1"
              @operatClick="operatClick"
            >
            </edit-list>
         </div>
      </div>
      <div class="cashierdiary--edit-dialog-wrapper-usering" v-if="useList.length">
         <div class="cashierdiary--edit-dialog-wrapper-title">
           <span>支出字段</span>
           <public-tips content="已添加字段不能修改格式类型,只能修改基本属性"></public-tips>
         </div>
         <!-- 列表 -->
         <div class="cashierdiary--edit-dialog-wrapper-list">
            <edit-list
              :listType="1"
              @getList="getList($event,1)"
              :dataList="useLists"
              :fillRule="2"
              @operatClick="operatClick"
            >
            </edit-list>
         </div>
      </div>
      <!-- 禁用字段 -->
      <div class="cashierdiary--edit-dialog-wrapper-disable" v-if="disableList.length">
        <div class="cashierdiary--edit-dialog-wrapper-title">
          <span>已禁用字段</span>
          <public-tips content="禁用后,保留所有数据,但不再显示在表单和列表之中,取消禁用可恢复显示"></public-tips>
        </div>
        <!-- 列表 -->
        <div class="cashierdiary--edit-dialog-wrapper-list">
          <edit-list
            :listType="2"
            :dataList="disableList"
            @getList="getList($event,2)"
            @operatClick="operatClick"
          >
          </edit-list>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import publicTips from "@/components/publicTips/toolTip.vue"
  import editList from "../dialogComponents/edit-list.vue"
  export default {
    components:{
      publicTips,editList
    },
    props:{
      useList:[Array]
    },
    data() {
      return {
        dialogVisible:false,
        loading:false,
        disableList:[],
        useLists:[]
      }
    },
    watch:{
      dialogVisible(val) {
        if(val) {
          this.$emit("closeKeyWatch")
        }else {
          this.$emit("openKeyWatch")
        }
      },
      useList(val) {
        this.useLists = this.$lodash.cloneDeep(val);
      },
    },
    created() {
      this.getDisableList();
    },
    methods:{
      // 更改值
      getList(e,type) {
        if(!e) return;
        if(type===1) {
          this.useLists = e;
        }else {
          this.disableList = e;
        }
        this.saveList(type);  // 保存拖动值
      },
       // 保存拖动值
      saveList(type) {
        // 格式化参数
        let arrData = this.$lodash.cloneDeep(this.useLists);
        arrData.forEach(i=>{
           i.value = "";
        })
        this.loading = true;
        this.$http.post('custom/sortCustom' , {columnList:arrData}).then(res=>{
          this.loading = false;
        	if(res&&res.data.code == 1) {
        		this.$emit('getCustomItem',true);
        		this.$message.success(res.data.msg)
        	}
        })
      },
      // 操作
      operatClick(item,row) {
        if(item.id === 1) {  // 编辑
           this.$emit("editField",row)
        }else if(item.id === 2 || item.id === 3) {  // 禁用&&取消禁用
          let status = (item.id === 2)?"1":"2";
          this.disabled(status,row);
        }else if(item.id === 4) {  // 删除
          this.deleteItem(row);
        }
      },
      // 删除操作
      deleteItem(row) {
        this.$confirm('此操作将删除该自定义列, 数据将不可恢复，是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.loading = true;
              	this.$http.post('custom/deleteCustomColumn' , {id:row.id}).then(res=>{
                  this.loading = false;
                if(res&&res.data.code == 1) {
                  if(row.state===1) {
                    this.$emit('getCustomItem',true);
                  }else {
                    this.getDisableList();
                  }
                  this.$message({
                    type: 'success',
                    message: res.data.msg
                  });
                }
        		})

        })
      },
      // 禁用操作 && 解除禁用操作  status 禁用 "1"   取消禁用 "2"
      disabled(status,row) {
        let hit = status==="1"?"此操作将禁用该自定义列,是否继续?":"是否取消禁用？";
        this.$confirm(hit, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.loading = true;
              	this.$http.post('custom/bandCustomColumn' , {customColumnId:row.id,type:status}).then(res=>{
                  this.loading = false;
                if(res&&res.data.code == 1) {
                  this.getDisableList();
                  this.$emit('getCustomItem',true);
                  this.$message({
                    type: 'success',
                    message: res.data.msg
                  });
                }
        		})

        })
      },
      // 获取禁用列表
      getDisableList(){
        this.loading = true;
      	this.$http.post('custom/getBandCustomColumn' , {}).then(res=>{
          this.loading = false;
      		if(res&&res.data.code == 1) {
      			this.disableList = res.data.data;
      		}
      	})
      },
    }
  }
</script>

<style lang="less" scoped>
  @import "../../../../../assets/css/cashierdiary/c-edit-dialog.less";
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/cashierdiaryTable/attr/edit-c-dialog.vue